export const CLIENTS_PANEL_FILTERS_INITIAL_VALUES = {
  keywords: "",
  country: null,
  city: "",
}
